import SMSTestSendModal from './SMSTestSendModal';

export default SMSTestSendModal;
